import {withStyles} from "@mui/styles";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import styles from "./Live4tvApi-jss";
import {cancelAddLive4tvApi, loginToLive4tvApi, resetIntegration} from "./live4tvApiActions";
import {InstagramDriver, StreamTargetIntegration} from "../StreamTargetIntegration/streamTargetIntegrationDTO";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import classNames from "classnames";
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormLabel,
    IconButton,
    LinearProgress,
    Radio,
    RadioGroup,
    TextField
} from "@mui/material";
import {Check, Facebook, FileCopyOutlined, Instagram, LiveTv, YouTube} from "@mui/icons-material";
import {StreamTargetList, StreamTargetType} from "../StreamTarget/streamTargetDTO";
import {Live4tvApiAuthRequest} from "./live4tvApiDTO";
import {Profile} from "../User/userDTO";
import {State} from "./live4tvApiReducer";
import {SiTiktok, SiTwitch} from "react-icons/si";

type Properties = {
    classes: any,
    open: boolean,
    streamTargetIntegration: StreamTargetIntegration,
    streamTargets: StreamTargetList,
    profile: Profile,
    live4tvApiIntegration: State,
    onClose: Function,
    loginToLive4tvApi: Function,
    cancelAddLive4tvApi: Function,
    resetIntegration: Function,
}

function Live4tvApi(props: Properties) {
    const {
        classes,
        open,
        streamTargetIntegration,
        profile,
        live4tvApiIntegration,
        onClose,
        loginToLive4tvApi,
        cancelAddLive4tvApi,
        resetIntegration,
    } = props;

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string|null>('');
    const [infoMessage, setInfoMessage] = useState<string|null>('');
    const [loginUrl, setLoginUrl] = useState<string|undefined>(undefined);
    const [instagramDriver, setInstagramDriver] = useState<InstagramDriver>('instagram-bridge');
    const {t} = useTranslation();

    const [copyIcon, setCopyIcon] = useState<Record<string, JSX.Element>>({
            url: <FileCopyOutlined />,
            key: <FileCopyOutlined />
        }
    );

    useEffect(() => {
        console.debug('Live4tvApi.tsx live4tvApiIntegration', live4tvApiIntegration);
        setIsLoading(live4tvApiIntegration.isLoading);
        setErrorMessage(live4tvApiIntegration.errorMessage || null);
        setInfoMessage(live4tvApiIntegration.infoMessage || null);
        setLoginUrl(live4tvApiIntegration.loginUrl || undefined);
    }, [live4tvApiIntegration]);

    function handleCancel() {
        setIsLoading(false);
        cancelAddLive4tvApi();
    }

    function handleLogin(e: any) {
        e.preventDefault();
        resetIntegration();
        const request: Live4tvApiAuthRequest = {
            profile,
            network: streamTargetIntegration.code,
            ...(streamTargetIntegration.code === StreamTargetType.INSTAGRAM ? {instagramDriver} : {}),
        }

        loginToLive4tvApi(request);
    }

    function getIcon() {
        switch (streamTargetIntegration.code) {
            case StreamTargetType.INSTAGRAM:
                return <Instagram />
            case StreamTargetType.FACEBOOK:
                return <Facebook />
            case StreamTargetType.YOUTUBE:
                return <YouTube sx={{ minWidth: 20, minHeight: 20, width: 20, height: 20 }} />
            case StreamTargetType.TWITCH:
                return <SiTwitch />
            case StreamTargetType.TIKTOK:
                return <SiTiktok />
            default:
                return <LiveTv />
        }
    }

    const copyToClipBoard = (text: string, kind: string) => {
        window.navigator.clipboard.writeText(text);
        setCopyIcon({...copyIcon, [kind]: <Check />});
        setTimeout(() => setCopyIcon({...copyIcon, [kind]: <FileCopyOutlined />}), 500);
    }

    const getCopyIcon = (kind: string) => {
        return copyIcon[kind];
    }

    return (
        <Dialog open={open} onClose={() => onClose()} className={classNames(classes.dialog)} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">
                <div className={classNames(classes.wrapIcon)}>
                    {/*getIcon()*/} <span>{t("Stream to {{integration}}", {integration: t(streamTargetIntegration.code)})}</span>
                </div>
            </DialogTitle>

            <DialogContent>
                { isLoading ? (
                    <>
                        <p>{ t('Please proceed the login at your web browser (Google Chrome, Microsoft Edge, Safari, Firefox), after the system automatic close this box') }</p>
                        <LinearProgress className={classNames(classes.progressBar)} />


                        { loginUrl &&
                            <>
                                <p>
                                    <Alert severity="info" className={classNames(classes.alert)}>{ t('In case the login page didn\'t open automatically, you can use the url below.') }</Alert>
                                </p>
                                <p>
                                    <FormControl fullWidth className={classNames(classes.radioField)}>
                                        <a href={loginUrl} target="_blank" rel="noopener noreferrer">{ loginUrl }</a>
                                    </FormControl>
                                </p>
                            </>
                        }
                    </>
                ) : (
                    <div className={classNames(classes.dataGrid)}>
                        { errorMessage ?
                            <>
                                <Alert severity="error" className={classNames(classes.alert)}>{ t(errorMessage) }</Alert>
                                <FormControl fullWidth className={classNames(classes.radioField)}>
                                </FormControl>
                            </>
                            : ''
                        }

                        { infoMessage ?
                            <>
                                <Alert severity="info" className={classNames(classes.alert)}>{ t(infoMessage) }</Alert>
                                <FormControl fullWidth className={classNames(classes.radioField)}>
                                </FormControl>
                            </>
                            : ''
                        }

                        { live4tvApiIntegration.streamTarget ? <>
                            <div className={classNames(classes.wrapIcon)}><b>{t('Account')}:</b>{getIcon()} <span>{live4tvApiIntegration.streamTarget.title}</span></div>
                            <FormControl fullWidth className={classNames(classes.radioField)}>
                            </FormControl>
                        </> : null }

                        {streamTargetIntegration.code === StreamTargetType.INSTAGRAM ? (
                            <FormControl fullWidth className={classNames(classes.radioField)}>
                                <FormLabel>{t('Instagram connection method')}</FormLabel>
                                <RadioGroup
                                    value={instagramDriver}
                                    onChange={(event) => setInstagramDriver(event.target.value as InstagramDriver)}
                                >
                                    <FormControlLabel
                                        value="instagram-bridge"
                                        control={<Radio />}
                                        label={t('Integration 1 (recommended)')}
                                    />
                                    <small>
                                        {t('Recommended for most accounts.')}
                                    </small>
                                    <FormControlLabel
                                        value="igpapi-thin"
                                        control={<Radio />}
                                        label={t('Integration 2')}
                                    />
                                    <small>
                                        {t('Alternative connection method for compatibility.')}
                                    </small>
                                </RadioGroup>
                            </FormControl>
                        ) : null}

                        <Button size="large" variant="contained" color="primary" className={classNames(classes.wrapIcon)} onClick={handleLogin}>
                            {/*getIcon()*/} <span>{t("Login on {{integration}}", {integration: t(streamTargetIntegration.code)})}</span>
                        </Button>
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>
                    {t("Cancel")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const mapStateToProps = function (state: any) {
    return {
        profile: state.user.profile,
        streamTargets: state.streamTargets,
        live4tvApiIntegration: state.live4tvApiIntegration,
    }
}

const mapDispatchToProps = function (dispatch: Dispatch) {
    return {
        cancelAddLive4tvApi: () => dispatch(cancelAddLive4tvApi()),
        loginToLive4tvApi: (request: Live4tvApiAuthRequest) => dispatch(loginToLive4tvApi(request)),
        resetIntegration: () => dispatch(resetIntegration()),
    };
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Live4tvApi));
